const { createContext } = require('react');

const AuthContext = createContext(null);

export default AuthContext;
